import { Navigate, useNavigate } from "react-router";
import Login from "../veiws/Website/authentication/Login/login";
import { uniqueId } from "lodash";
import { IconAperture, IconCopy, IconLayoutDashboard,   IconLogin, IconMoodHappy, IconTypography, IconRegistered, IconUserPlus } from '@tabler/icons';
import './routeAndHeader.css'
import { AddCard, Api, AddAlert, AppRegistration, Assessment, AssignmentReturn, Bloodtype, InstallMobile, CallSplit, DirectionsTransit, DataSaverOn, Dialpad, GradeOutlined, VerifiedUserRounded, StickyNote2Rounded, FlightClassOutlined, Games, Subject, Inventory, Receipt, EditCalendar, CurrencyExchange, ImportExport, QrCodeScanner, SettingsSuggest, Category, Equalizer, Group, AttachMoney, CardTravel, HelpOutline, CloudDownload, TrendingDown, TrendingUp, Payment, QueuePlayNext } from "@mui/icons-material";
import Dashboard from "../veiws/Dashboard/Dashboard/Dashboard";
import { User_Data } from "../hooks/Requests/localStroagedata";
import { Typography } from "@mui/material";
import RegistrationForm from "../veiws/Website/Contact/mainPages/registrationForm";
import ActiviationForm from "../veiws/Website/Contact/mainPages/activationForm";
 import Supplier from "../veiws/Dashboard/suplier/suplier";
import Purchase from "../veiws/Dashboard/purchase/purchase";
import Sale from "../veiws/Dashboard/sale/sale";
import ReceiptComp from "../veiws/Dashboard/receipt/receipt";
import RefundComp from "../veiws/Dashboard/refund/refund"; 
import { Logout } from "../redux/actions/loginauth";
import SystemSettings from "../veiws/Dashboard/systemSettings/systemSettings";
import Roznamcha from "../veiws/Dashboard/report/component/roznamcha/roznamcha";
import Expenses from "../veiws/Dashboard/report/component/expenses";
 import Capital from "../veiws/Dashboard/report/component/capital/capital";
import Auth from "../veiws/Dashboard/report/component/auth";
import ProductDetails from "../veiws/Dashboard/report/component/productDetail";
 import Customers from "../veiws/Dashboard/customers/customers";
import PurchaseEdit from "../veiws/Dashboard/purchaseEdit/purchaseEdit";
import Income from "../veiws/Dashboard/Income/Income";
import SupplierReturns from "../veiws/Dashboard/suplier/component/supplierReturns";
import PaySupplier from "../veiws/Dashboard/suplier/component/paySupplier";
import HelpComponent from "../veiws/Dashboard/help/help";
import SystemBackup from "../veiws/Dashboard/systemBackup/systemBackup";
import CapitalRemove from "../veiws/Dashboard/report/component/capital/capitalDeduct";
import SalaryAndDeposit from "../veiws/Dashboard/report/component/salaryAndDeposit";
import ExpiryList from "../veiws/Dashboard/expiryDateList/expiryList";
import QuantityCheck from "../veiws/Dashboard/quntityChecker/quantityCheck";

// //console.log(SelectedData())
export const RouteHeader = () => { 
//  //console.log(User_Data)
 const userToken = JSON.parse(localStorage.getItem('User_Data'))?.role || undefined;

let getRoles = userToken == undefined ? undefined : userToken  == undefined ? 'empty' : userToken;
// //console.log(getRoles)
return {
    router:{
       
      SinglePage: [
        {path:'/' , element: <div className="menuItem"><Login/></div> },  
        // {path:'/login' , element: <div id="Login"><Login /></div>},
        // {path:'/registration', element:<div id="RegistrationForm"><RegistrationForm /></div>},
        // {path:'/activation', element:<div id="ActivationForm"><ActiviationForm/></div>},
        {
          path: '*',
          element: <Navigate to="/" replace />
        }
      ],
        Menu:[
          ...(User_Data == undefined  ? [] : User_Data == 'empty' ? [] : [
            {path:'/Private/' , element: <Navigate to="/Private/Home" /> },
          
                  {
                    item: true,
                    navlabel: true,
                    subheader: <div className="mainMenuMain"><Typography variant="span" sx={{display: (theme)=>theme.palette.sidemenutext.display.display}}>Sale </Typography><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>خرڅ</Typography></div>,
                    title: '',
                    icon: '',
                    href: '',
                    path: '',
                    element: ''
                  },
                  {
                    item: true,
                    navlabel: false,
                    subheader: '',
                    title: <div className="menuItem"><span>Dashboard </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}> ډشبورډ </Typography></div>,
                    icon: IconLayoutDashboard,
                    href: '/Private/Home',
                    path: '/Private/Home',
                    element: <div id="Dashboard"><Sale /></div>
                  }, 
                  {
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Refund </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}> بیرته ستنیدل</Typography></div>,
                    icon: CallSplit,
                    href: '/Private/Refund',
                    path: '/Private/Refund',
                    element: <div id="Refund"><RefundComp /></div>
                  },
                  {
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Receipt </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  رسید  </Typography></div>,
                    icon: Receipt,
                    href: '/Private/Receipt',
                    path: '/Private/Receipt',
                    element: <div id="Receipt"><ReceiptComp /></div>
                  }, 
                   {
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Daily Cash </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  روزنامچه  </Typography></div>,
                    icon: ImportExport,
                    href: '/Private/Roznamcha',
                    path: '/Private/Roznamcha',
                    element: <div id="Roznamcha"><Roznamcha /></div>
                    }, 
                   {
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Expenses </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  مصارف  </Typography></div>,
                      icon: EditCalendar,
                      href: '/Private/Expenses',
                      path: '/Private/Expenses',
                      element: <div id="Expenses"><Expenses /></div>
                    }, 
                  {
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Customers </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}> مشتری کهاته</Typography></div>,
                    icon: Group,
                    href: '/Private/Customers',
                    path: '/Private/Customers',
                    element: <div id="Customers"><Customers /></div>
                  }, 
                  { //Medical
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Product Expiray Date </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>دختمیدو  نیټه</Typography></div>,
                    icon: QueuePlayNext,
                    href: '/Private/ExpireList',
                    path: '/Private/ExpireList',
                    element: <div id="ExpireList"><ExpiryList /></div>
                  }, 
                  
                  { 
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Quantity  </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>د مقدار چک</Typography></div>,
                    icon: Bloodtype,
                    href: '/Private/QuantityCheck',
                    path: '/Private/QuantityCheck',
                    element: <div id="QuantityCheck"><QuantityCheck /></div>
                  }, 
                  {
                    item: true,
                    id: uniqueId(),
                    title: <div className="menuItem"><span>Video Tutorial </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>کمکی ویډیوګانې</Typography></div>,
                    icon: HelpOutline,
                    href: '/Private/Help',
                    path: '/Private/Help',
                    element: <div id="Help"><HelpComponent /></div>
                  },
 
      
                  ...( getRoles == 1 ? [{
                    item: true,
                    navlabel: true,
                    subheader: <div className="mainMenuMain"><Typography variant="span" sx={{display: (theme)=>theme.palette.sidemenutext.display.display}}>Purchase </Typography><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>خرید</Typography></div>,
                    title: '',
                    icon: '',
                    href: '',
                    path: '',
                    element: ''
                  }] : []),

       

                  // ...( getRoles != 1
                  //   ? []
                  //   :
                  //   [{
                  //   item: true,
                  //   id: uniqueId(),
                  //   title: <div className="menuItem"><span>Purchase </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>خرید</Typography></div>,
                  //   icon: DataSaverOn,
                  //   href: '/Private/Purchase',
                  //   path: '/Private/Purchase',
                  //   element: <div id="StudentReport"><Purchase /></div>
                  // }]), 

                  // ...( getRoles != 1
                  //   ? []
                  //   :
                  //   [{
                  //   item: true,
                  //   id: uniqueId(),
                  //   title: <div className="menuItem"><span>Purchase Edit </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>ترمیم خرید</Typography></div>,
                  //   icon: Dialpad,
                  //   href: '/Private/PurchaseEdit',
                  //   path: '/Private/PurchaseEdit',
                  //   element: <div id="StudentReport"><PurchaseEdit /></div>
                  // }]),  

                  ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Product </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  جنس  </Typography></div>,
                      icon: Category,
                      href: '/Private/Product',
                      path: '/Private/Product',
                      element: <div id="Product"><ProductDetails /></div>
                    }]),
                    
                    ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Supplier </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}> عرضه کوونکی</Typography></div>,
                      icon: Assessment,
                      href: '/Private/Supplier',
                      path: '/Private/Supplier',
                      element: <div id="StudentReport"><Supplier /></div>
                    }]), 
                    
                    
                    ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Supplier Account</span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>عرضه کوونکي کهاته</Typography></div>,
                      icon: CardTravel,
                      href: '/Private/SupplierPay',
                      path: '/Private/SupplierPay',
                      element: <div id="StudentPay"><PaySupplier /></div>
                    }]),

                    ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Return</span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}> عرضه کوونکی ته واپس</Typography></div>,
                      icon: AssignmentReturn,
                      href: '/Private/SupplierReturn',
                      path: '/Private/SupplierReturn',
                      element: <div id="StudentReturn"><SupplierReturns /></div>
                    }]), 
                     
                
     
                  ...( getRoles == 1 ? [{
                    item: true,
                    navlabel: true,
                    subheader: <div className="mainMenuMain"><Typography variant="span" sx={{display: (theme)=>theme.palette.sidemenutext.display.display}}>Finance </Typography><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>مالیه</Typography></div>,
                    title: '',
                    icon: '',
                    href: '',
                    path: '',
                    element: ''
                  }] : []),
                                      
                  
                    ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Capital Add</span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  پانګونه  </Typography></div>,
                      icon: TrendingUp,
                      href: '/Private/Capital',
                      path: '/Private/Capital',
                      element: <div id="Capital"><Capital /></div>
                    }]),         
                  
                    ...( getRoles != 1
                      ? []
                      :
                      [{
                      item: true,
                      id: uniqueId(),
                      title: <div className="menuItem"><span>Capital Remove</span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  د پانګی خروج  </Typography></div>,
                      icon: TrendingDown,
                      href: '/Private/CapitalRemove',
                      path: '/Private/CapitalRemove',
                      element: <div id="CapitalRemove"><CapitalRemove /></div>
                    }]), 

                    ...( getRoles == 1 ? [{
                          item: true,
                          id: uniqueId(),
                          title: <div className="menuItem"><span>Salary </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>معاش او اډوانس</Typography></div>,
                          icon: Payment,
                          href: '/Private/Salary',
                          path: '/Private/Salary',
                          element: <div id="SalarySettings"><SalaryAndDeposit /></div>
                        },
                    ] : []), 

                    ...( getRoles == 1 ? [{
                          item: true,
                          id: uniqueId(),
                          title: <div className="menuItem"><span>Finance </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>مالیه</Typography></div>,
                          icon: AttachMoney,
                          href: '/Private/Finance',
                          path: '/Private/Finance',
                          element: <div id="FinanceSettings"><Income /></div>
                        },
                    ] : []), 

                    ...( getRoles == 1 ? [{
                    item: true,
                    navlabel: true,
                    subheader: <div className="mainMenuMain"><Typography variant="span" sx={{display: (theme)=>theme.palette.sidemenutext.display.display}}>Settings</Typography><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>ترتیبات</Typography></div>,
                    title: '',
                    icon: '',
                    href: '',
                    path: '',
                    element: ''
                  }] : []),

                    
                  // ...( getRoles != 1
                  //     ? []
                  //     :
                  //     [{
                  //     item: true,
                  //     id: uniqueId(),
                  //     title: <div className="menuItem"><span>Barcode </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>  بارکوډ  </Typography></div>,
                  //     icon: QrCodeScanner,
                  //     href: '/Private/Barcode',
                  //     path: '/Private/Barcode',
                  //     element: <div id="Barcode"><Auth /></div>
                  //   }]), 

                  ...( getRoles == 1 ? [{
                        item: true,
                        id: uniqueId(),
                        title: <div className="menuItem"><span>System Settings </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>د سیسټم ترتیبات</Typography></div>,
                        icon: SettingsSuggest,
                        href: '/Private/System',
                        path: '/Private/System',
                        element: <div id="SystemSettings"><SystemSettings /></div>
                      },
                    ] : []), 
                  // ...( getRoles == 1 ? [{ //NO need for online application
                  //       item: true,
                  //       id: uniqueId(),
                  //       title: <div className="menuItem"><span>Backup </span><Typography variant="span" sx={{fontSize: '14px',marginLeft: '1px',display: (theme)=>theme.palette.sidemenutext.display.display, display: 'inline'}}>بیک اپ</Typography></div>,
                  //       icon: CloudDownload,
                  //       href: '/Private/Backup',
                  //       path: '/Private/Backup',
                  //       element: <div id="BackupSettings"><SystemBackup /></div>
                  //     },
                  //   ] : []),  
             
        ])]
    }
  }
}